import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import { caseStudyPages } from "../data/seoLandingData";

export default function CaseStudyPage() {
  const { slug } = useParams();
  const pageData = caseStudyPages[slug];

  if (!pageData) {
    return (
      <main className="mx-auto max-w-4xl px-4 py-20 text-center">
        <h1 className="text-3xl font-bold text-slate-900">Case study not found</h1>
        <p className="mt-3 text-slate-600">This project story is not available.</p>
      </main>
    );
  }

  return (
    <>
      <Helmet>
        <title>{pageData.title} | Suraksha 24X7</title>
        <meta name="description" content={pageData.summary} />
        <meta name="keywords" content={`${pageData.city}, ${pageData.industry}, security project, CCTV installation`} />
        <link rel="canonical" href={`https://www.suraksha24x7.com/case-study/${pageData.slug}`} />
      </Helmet>

      <main className="bg-slate-50 text-slate-900">
        <section className="bg-slate-950 py-20 text-white">
          <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-300">Case study</p>
            <h1 className="mt-4 max-w-4xl text-4xl font-bold leading-tight md:text-5xl">
              {pageData.title}
            </h1>
            <p className="mt-5 max-w-3xl text-lg text-slate-300">{pageData.summary}</p>
          </div>
        </section>

        <section className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">City</p>
              <p className="mt-3 text-xl font-bold text-slate-900">{pageData.city}</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Industry</p>
              <p className="mt-3 text-xl font-bold text-slate-900">{pageData.industry}</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500">Outcome</p>
              <p className="mt-3 text-xl font-bold text-slate-900">Improved security</p>
            </div>
          </div>

          <div className="mt-12 space-y-10">
            <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
              <h2 className="text-2xl font-bold text-slate-900">Challenge</h2>
              <p className="mt-4 text-slate-700">{pageData.challenge}</p>
            </div>

            <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
              <h2 className="text-2xl font-bold text-slate-900">Solution</h2>
              <p className="mt-4 text-slate-700">{pageData.solution}</p>
            </div>

            <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
              <h2 className="text-2xl font-bold text-slate-900">Results</h2>
              <p className="mt-4 text-slate-700">{pageData.result}</p>
            </div>
          </div>

          <div className="mt-12 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
            <h2 className="text-2xl font-bold text-slate-900">Key deliverables</h2>
            <ul className="mt-6 grid gap-4 md:grid-cols-2">
              {pageData.deliverables.map((item) => (
                <li key={item} className="flex items-start gap-3 rounded-xl bg-slate-50 p-4 text-slate-700">
                  <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white">✓</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="bg-slate-900 py-16 text-white">
          <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold md:text-4xl">{pageData.cta}</h2>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link
                to="/contact"
                className="rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white hover:bg-blue-500"
              >
                Talk to our team
              </Link>
              <Link
                to="/security-product"
                className="rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white hover:bg-white/5"
              >
                View security products
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
